/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContentTemplateListResponse } from '../../models/get-content-template-list-response';

export interface GetContentTemplates$Params {
}

export function getContentTemplates(http: HttpClient, rootUrl: string, params?: GetContentTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContentTemplateListResponse>> {
  const rb = new RequestBuilder(rootUrl, getContentTemplates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContentTemplateListResponse>;
    })
  );
}

getContentTemplates.PATH = '/admin/contentTemplate';
